@for (widget of input.widgets; track trackByWidgetId($index, widget)) {
  <ng-container [dynamicWidget]="widget" [context]="context" />
}
